import { render, staticRenderFns } from "./Expertise.vue?vue&type=template&id=3208db4a&"
import script from "./Expertise.vue?vue&type=script&lang=js&"
export * from "./Expertise.vue?vue&type=script&lang=js&"
import style0 from "./Expertise.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports